import { render, staticRenderFns } from "./_eventHighlight.vue?vue&type=template&id=196e88fa&scoped=true&lang=pug&"
import script from "./_eventHighlight.vue?vue&type=script&lang=js&"
export * from "./_eventHighlight.vue?vue&type=script&lang=js&"
import style0 from "./_eventHighlight.vue?vue&type=style&index=0&id=196e88fa&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196e88fa",
  null
  
)

export default component.exports